import { render, staticRenderFns } from "./UserInfo.vue?vue&type=template&id=7f26b976&scoped=true&"
import script from "./UserInfo.vue?vue&type=script&setup=true&lang=js&"
export * from "./UserInfo.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./UserInfo.vue?vue&type=style&index=0&id=7f26b976&prod&lang=scss&scoped=true&"
import style1 from "./UserInfo.vue?vue&type=style&index=1&id=7f26b976&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f26b976",
  null
  
)

export default component.exports
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QSeparator,QImg,QBtn,QField});
